import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import NewNav from '../components/NewNav';
import consumer from "../images/consumer.webp"
import professional from "../images/professional.webp"
import Footer from '../components/Footer';
import pcb from "../images/pcb.webp";
import smartlght from "../images/smartlight.webp"
import ImageSliderTabs from '../components/ImageSliderTabs';
import BentoGrid from '../components/BentoGrid';


const Product = () => {
  return (
    <div className="pro-wrapper">
      <NewNav/>

    <div className="experience-header">
  <Row className="section-boxes">
    {/* Card 1 */}
    <Col xs={12} sm={6} md={3} className="section-boxes-wrap">
      <a href="/consumer-product">
        <div className="section-title">
          <div className="section-projects-overflow">
            <Card className="section-box">
              <div className="swiper-zoom-container">
                <img src={consumer} alt="Project 1" />
              </div>
            </Card>
          </div>
          <div className="project-type">
            <h2>Consumer</h2>
          </div>
        </div>
      </a>
    </Col>

    {/* Card 2 */}
    <Col xs={12} sm={6} md={3} className="section-boxes-wrap">
      <a href="/perfessional-product">
        <div className="section-title">
          <div className="section-projects-overflow">
            <Card className="section-box">
              <div className="swiper-zoom-container">
                <img src={professional} alt="Project 2" />
              </div>
            </Card>
          </div>
          <div className="project-type">
            <h2>Professional</h2>
          </div>
        </div>
      </a>
    </Col>

    {/* Card 3 */}

  

    <Col xs={12} sm={6} md={3} className="section-boxes-wrap">
      <a href="/Ourproduct">
        <div className="section-title">
          <div className="section-projects-overflow">
            <Card className="section-box">
              <div className="swiper-zoom-container">
                <img src={pcb} alt="Project 3" />
              </div>
            </Card>
          </div>
          <div className="project-type">
            <h2>PCB</h2>
          </div>
        </div>
      </a>
    </Col>

       {/* <Col xs={12} sm={6} md={3} className="section-boxes-wrap">
      <a href="/smartlighting">
        <div className="section-title">
          <div className="section-projects-overflow">
            <Card className="section-box">
              <div className="swiper-zoom-container">
                <img src={smartlght} alt="Project 4" />
              </div>
            </Card>
          </div>
          <div className="project-type">
            <h2>Smart Lighting</h2>
          </div>
        </div>
      </a>
    </Col> */}

    {/* Card 4 */}
   
  </Row>
</div>

    <BentoGrid/>
    <ImageSliderTabs/>
    <Footer/>
    </div>
  );
};

export default Product;


